import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import MainFont from 'ui/typography/mainFont';

import {
  CheckboxLabel,
  OptionOne,
  OptionTwo,
  ToggleSwitchWrapper,
  ToggleWrapper
} from './style';

const ToggleSwitch = ({
  checked,
  onChange,
  disabled,
  name,
  customMargin,
  margin,
  text,
  isMonitoring,
  labels,
  ...props
}) => {
  const [check, setCheck] = useState(checked);

  useEffect(() => {
    setCheck(checked);
  }, [checked]);

  const handleOnClick = () => {
    onChange(!check);
    setCheck(!check);
  };

  return (
    <ToggleWrapper>
      {labels && (
        <OptionOne checked={check}>
          <MainFont type="4" configuration={{ fontSize: 14 }}>
            {labels[0]}
          </MainFont>
        </OptionOne>
      )}
      <ToggleSwitchWrapper
        disabled={disabled}
        customMargin={customMargin}
        margin={margin}
        onClick={e => {
          e.stopPropagation();
          handleOnClick();
        }}
        {...props}
      >
        <input
          type="checkbox"
          checked={check}
          disabled={disabled}
          name={name}
          id={name}
          onChange={() => null}
          className="ios-toggle"
        />
        <CheckboxLabel
          type="checkboxLabel"
          htmlFor={name}
          className="checkbox-label"
          disabled={disabled}
          checked={check}
          {...props}
        />
      </ToggleSwitchWrapper>
      {text && <MainFont type="4">{text}</MainFont>}
      {labels && (
        <OptionTwo checked={check}>
          <MainFont type="4" configuration={{ fontSize: 14 }}>
            {labels[1]}
          </MainFont>
        </OptionTwo>
      )}
    </ToggleWrapper>
  );
};

ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  customMargin: PropTypes.string,
  margin: PropTypes.string,
  isMonitoring: PropTypes.bool,
  type: PropTypes.oneOf(['login', 'monitoring']),
  labels: PropTypes.array,
  text: PropTypes.string,
  name: PropTypes.string
};

ToggleSwitch.defaultProps = {
  checked: false,
  onChange: () => ({}),
  disabled: false,
  margin: '0',
  isMonitoring: false,
  labels: ['', '']
};

export default ToggleSwitch;
